export const apiRequestTimeout = 1000 * 25;
